// eslint-disable-next-line import/prefer-default-export
export const UPDATE_EMPLOYEE_GLOBAL_SETUP = 'UPDATE_EMPLOYEE_GLOBAL_SETUP';
